import { initReactI18next } from 'react-i18next'

import i18next, { InitOptions } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ChainedBackend from 'i18next-chained-backend'
import HttpBackend from 'i18next-http-backend'
import LocalStorageBackend from 'i18next-localstorage-backend'

const isDebugMode = process.env.NODE_ENV === 'development'

const namesSpaces = [
  'common',
  'projects',
  'projectfiles',
  'members',
  'services',
  'adapters',
  'globalmembers',
  'customize',
  'login',
  'templates',
  'customproperties',
  'globalparameters',
  'tenantfiles',
  'tenants',
  'apikeys',
  'configtransfer',
]

const initOptions: InitOptions = {
  supportedLngs: ['en', 'de'],
  backend: {
    backends: [LocalStorageBackend, HttpBackend],
    backendOptions: [
      {
        expirationTime: 1000, //60 * 60 * 1000, // 1 h
      },
      {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        allowMultiLoading: true,
      },
    ],
  },
  fallbackLng: 'en',
  debug: isDebugMode,
  ns: namesSpaces,
  defaultNS: 'common',
  nsSeparator: '.',
  interpolation: {
    escapeValue: false,
  },
}

i18next.use(ChainedBackend).use(LanguageDetector).use(initReactI18next).init(initOptions)

export default i18next
